<template>
  <div class="create-instance-form">
    <table>
      <tbody>
        <tr>
          <td>Feature:</td>
          <td>
            <select v-model="selectedAnnotationFeature">
              <option
                v-for="annotationFeature in visibleOrderedFeatures || []"
                :value="annotationFeature.uri"
                :key="annotationFeature.uri"
              >
                {{ annotationFeature?.label || annotationFeature.uri }}
              </option>
            </select>
          </td>
        </tr>
        <tr v-if="proposedTokenIds.length > 0">
          <td>Tokens:</td>
          <td>
            <div class="token-styles" :class="{ rtl }">
              <Token v-for="tokenId in proposedTokenIds" :key="tokenId" :tokenId="tokenId" />
            </div>
            <button @click="deselectTokens">Deselect Tokens</button>
          </td>
        </tr>
      </tbody>
    </table>
    <button @click="createInstance">Create Link</button>
    <button @click="$emit('close')">Cancel</button>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import { APOLLO_QUERY_FOR_ANNOTATION_INSTANCES } from '@/store/constants';
  import Token from '@/symphony/widgets/tokens/Token.vue';
  import { visibleOrderedFeaturesHelper } from '@/common/featureListLocalstorage';

  export default {
    props: {
      linkedToUri: {
        type: String,
        required: true,
      },
      annotationSetUri: {
        type: String,
        required: true,
      },
      annotationFeatures: {
        type: Array,
        required: true,
      },
      proposedTokenIds: {
        type: Array,
        required: false,
      },
    },
    emits: ['close', 'setRecentlyUpdatedInstanceUri'],
    inject: ['deselectTokens', 'rtl'],
    data() {
      return {
        selectedAnnotationFeature: null,
        newInstanceLabel: null,
      };
    },
    computed: {
      visibleOrderedFeatures() {
        return visibleOrderedFeaturesHelper(this.annotationSetUri, this.annotationFeatures);
      },
    },
    watch: {
      visibleOrderedFeatures: {
        immediate: true,
        handler() {
          this.selectedAnnotationFeature = this.visibleOrderedFeatures?.[0]?.uri;
        },
      },
    },
    methods: {
      createInstance() {
        const variables = {
          featureUri: this.selectedAnnotationFeature,
          linkedToUri: this.linkedToUri,
        };
        if (this.proposedTokenIds.length > 0) {
          variables.tokens = this.proposedTokenIds;
        }

        this.$apollo
          .mutate({
            mutation: gql`
              mutation ($featureUri: String!, $tokens: [ID!], $linkedToUri: String) {
                createAnnotation(
                  annotationFeatureUri: $featureUri
                  tokens: $tokens
                  sortTokens: true
                  linkedToUri: $linkedToUri
                ) {
                  __typename
                  ... on Annotation {
                    id
                    uri
                  }
                  ... on OperationInfo {
                    messages {
                      kind
                      message
                      field
                    }
                  }
                }
              }
            `,
            variables,
            refetchQueries: [APOLLO_QUERY_FOR_ANNOTATION_INSTANCES],
          })
          .then(({ data }) => {
            // eslint-disable-next-line no-underscore-dangle
            if (data?.createAnnotation?.__typename !== 'Annotation') {
              console.error('there was an error creating the annotation', data);
              return;
            }
            this.deselectTokens();
            this.$emit('setRecentlyUpdatedInstanceUri', this.linkedToUri);
            this.$emit('close');
          })
          .catch(error => {
            console.error('there was an error sending the query', error);
          });
      },
    },
    components: {
      Token,
    },
  };
</script>

<style scoped>
  .create-instance-form {
    padding: 0.5rem;
    border: 3px solid #eee;
    border-top: none;
  }
</style>
